var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.644 28.723l-7.535-7.535 7.535-7.536M6.185 21.188h21.412M20.097 15.402V7.236h17.541v28.25H20.097v-8.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitSimple);
export default __webpack_public_path__ + "static/media/exitSimple.18950a6cba4939efe974f25e81e23a6c.svg";
export { ForwardRef as ReactComponent };